import { ProductRequestModel } from './product.requestModel';

export const requestModel = (): typeof ProductRequestModel => {
    return ProductRequestModel;
};
